module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAFFJREFUOE9jZCACvBZnOA1SJvqSwZSQckZCCkDyr8UZ/kMNJKieoIJRAwkGEUEFwzAMoYnWhJj0SISaM4xUN5AIW0dzCv5AGokJe6CSDdFVAAAjADuv0aneaQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/group-add.png
// module id = YM9R
// module chunks = 1